exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-2a286e69]:hover {\n  text-decoration: none;\n}\n.logo__img[data-v-2a286e69] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  color: #ffffff;\n  font-size: 32px;\n  /* adjust until it fits well */\n  line-height: 60px;\n}\n.logo__img img[data-v-2a286e69] {\n    width: 188px;\n    height: 60px;\n}\n@media only screen and (max-width: 599px) {\n.logo__img[data-v-2a286e69] {\n      width: 120px;\n      height: 40px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a286e69","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/common/Logotype.vue
// module id = tO6X
// module chunks = 1